// Maps a 2-letter US state abbreviation to its full name.
export const US_STATES = {
  AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
  CO: "Colorado", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
  HI: "Hawaii", ID: "Idaho", IL: "Illinois", IN: "Indiana", IA: "Iowa",
  KS: "Kansas", KY: "Kentucky", LA: "Louisiana", ME: "Maine", MD: "Maryland",
  MA: "Massachusetts", MI: "Michigan", MN: "Minnesota", MS: "Mississippi", MO: "Missouri",
  MT: "Montana", NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
  NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota", OH: "Ohio",
  OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina",
  SD: "South Dakota", TN: "Tennessee", TX: "Texas", UT: "Utah", VT: "Vermont",
  VA: "Virginia", WA: "Washington", WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming",
  DC: "District of Columbia",
};

const FULL_NAMES = new Set(Object.values(US_STATES).map((n) => n.toLowerCase()));

// Derives a full state name from a free-form location string.
// e.g. "Orem / Utah County, UT" -> "Utah"; "Brooklyn, New York" -> "New York".
// Returns "Other" when no state can be parsed.
export function stateFromLocation(location) {
  if (!location) return "Other";
  const last = location.split(",").pop().trim();
  // strip a trailing ZIP if present: "UT 84058" -> "UT"
  const token = last.split(/\s+/)[0].trim();
  const abbr = token.toUpperCase();
  if (US_STATES[abbr]) return US_STATES[abbr];
  if (FULL_NAMES.has(last.toLowerCase())) return last;
  return "Other";
}
